export SimpleMenu from './SimpleMenu'
export MenuItem from './MenuItem'
export MenuAnchor from './MenuAnchor'

export default from './SimpleMenu'



// WEBPACK FOOTER //
// ./src/Menu/index.js